module.exports = __webpack_public_path__ + "cde85ac9dbec496254434c7b63ae6779.pdf";